import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Container } from "reactstrap";
import { XCircleLoader } from "components";
import { useTranslate } from "hooks";
import { useProductsOverviewStore } from "stores/productsOverviewStore";
import s from "./ProductsOverview.module.scss";
import { ProductsOverviewHeader } from "./ProductsOverviewHeader";
import { ProductsOverviewBody } from "./ProductsOverviewBody";

export const ProductsOverview = Scrivito.connect(
  ({ error, title, isModalActive, ...rest }) => {
    const translate = useTranslate();
    const isImageFetching = useProductsOverviewStore(
      (state) => state.isImageFetching,
    );

    return (
      <>
        {isImageFetching ? (
          <XCircleLoader classNames="position-absolute bg-gray-100 d-flex h-100 w-100 overflow-hidden z-1" />
        ) : (
          <Container
            className={cx("pb-8 w-100", {
              [s.productsWrapper]: !isModalActive,
            })}
          >
            <ProductsOverviewHeader
              {...{
                title:
                  title || translate("PRODUCTS_OVERVIEW_PRODUCTS_LIST_TITLE"),
                isModalActive,
              }}
              {...rest}
            />
            <ProductsOverviewBody
              {...{
                error,
                isModalActive,
              }}
              {...rest}
            />
          </Container>
        )}
      </>
    );
  },
);
